var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 54,
    viewBox: "0 0 219 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21353 4.61383C74.7813 4.61383 215.539 0.425817 215.539 0.425817C215.539 0.425817 220.097 24.1589 218.035 44.7709C103.638 53.0158 5.73076 53.0158 5.73076 53.0158C5.73076 53.0158 -2.51401 22.0975 1.21353 4.61383Z",
    fill: "#FEEB45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBg);
export default __webpack_public_path__ + "static/media/yellow-bg.1f1a0a315c62850b747ba506b4d167d4.svg";
export { ForwardRef as ReactComponent };